
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","height":"48","viewBox":"0 96 960 960","width":"48"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M393 891l279-335H492l36-286-253 366h154l-36 255zm-33-195H217q-17.872 0-26.436-16T193 649l338-488q8-11 20-15t24 1q12 5 19 16.17 7 11.17 5 23.83l-39 309h176q19.362 0 27.181 17Q771 530 759 545L388 990q-8.442 9.905-20.721 12.95Q355 1006 344 1000.75t-17.5-16.125Q320 973.75 322 961l38-265zm113-115z"}})])
          )
        }
      }
    